import styled from 'styled-components'

import theme from '~/truck/theme'

export const Container = styled.div`
  display: flex;

  > :first-child {
    margin-right: ${theme.spacing.cozy * 8}px;
  }
`

export const ThumbnailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.spacing.comfortable}px;

  > :not(:last-child) {
    margin-bottom: ${theme.spacing.comfortable}px;
  }
`

const getSelectedColor = props => {
  return props.theme.colors.primary
}

const getThumbnailBorderColor = props => {
  const { selected } = props

  if (selected) {
    return getSelectedColor(props)
  }

  return 'transparent'
}

export const Thumbnail = styled.img<{ selected: boolean }>`
  background-color: ${theme.colors.white};
  border: 1px solid transparent;
  border-color: ${getThumbnailBorderColor};
  cursor: pointer;
  height: ${theme.spacing.cozy * 8}px;
  object-fit: contain;
  transition: border-color 0.2s ease-in;
  width: ${theme.spacing.cozy * 8}px;

  :hover {
    border-color: ${getSelectedColor};
  }
`
